import { keyframes } from '@emotion/react';

const PULSE_FROM_SHADOW = '0 0 0 0 rgba(255, 73, 53, 0.55)';
const PULSE_TO_SHADOW = '0 0 0 10px rgba(255, 73, 53, 0)';
const PULSE_CYCLE_MS = 750;
const PULSE_CYCLES = 2;
const PULSE_EASING = 'ease-out';

export const posterPulseKeyframes = keyframes`
  0%   { box-shadow: ${PULSE_FROM_SHADOW}; }
  100% { box-shadow: ${PULSE_TO_SHADOW}; }
`;

export const POSTER_PULSE_KEYFRAMES: Keyframe[] = [
  { boxShadow: PULSE_FROM_SHADOW },
  { boxShadow: PULSE_TO_SHADOW },
];

export const POSTER_PULSE_OPTIONS: KeyframeAnimationOptions = {
  duration: PULSE_CYCLE_MS,
  easing: PULSE_EASING,
  iterations: PULSE_CYCLES,
};

export const getPulseAnimation = (
  shouldPulse: boolean,
  delayMs = 0
): string | undefined =>
  shouldPulse
    ? `${posterPulseKeyframes} ${PULSE_CYCLE_MS}ms ${PULSE_EASING} ${delayMs}ms ${PULSE_CYCLES}`
    : undefined;
